import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  async createAdas({ commit, state, dispatch }, data) {
    const r = await startLoading(dispatch, 'createAdas', () => http.post('decode/createAdas', data))
    commit(types.SET_ADAS_IDS, r.data)
    return r.data
  },
  async getAdasInspection({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getAdasInspection', () =>
      http.get(`decode/adasInspection?adasInspection=${data.adasInspection}&calibrateEvent=${data.calibrateEvent}`)
    )
    commit(types.SET_ADASINSPECTION, r.data)
    return r.data
  },
  async getAdasMatrices({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getAdasMatrices', () =>
      http.get('decode/getAdasMatrix', {
        params: options
      })
    )
    commit(types.SET_ADAS_MATRICES, r.data)
    return r.data
  },
  async getGeneralInfoLinks({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getLinks', () =>
      http.get('decode/getGeneralInfoLinks', {
        params: data
      })
    )
    commit(types.SET_LINKS, r.data)
    return r.data
  },
  async getLinks({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getLinks', () =>
      http.get('decode/getLinks', {
        params: data
      })
    )
    commit(types.SET_LINKS, r.data)
    return r.data
  },
  async decodeVIN({ commit, dispatch }, vin) {
    const r = await startLoading(dispatch, 'decodeVIN', () => http.get(`decode/vin?vin=${vin}`))
    return r.data
  },
  async adasLookups({ commit, dispatch, state }, data) {
    let _keys = data.keys.filter(k => !state.lookups[k])
    if (data.refresh === undefined || data.refresh === null) {
      data.refresh = false
    }
    if (_keys.length || data.refresh) {
      const r = await startLoading(dispatch, 'adasLookups', () =>
        http.post('decode/getKeys', {
          keys: data.keys,
          firm: data.firm,
          showInactive: false
        })
      )
      commit(types.SET_LOOKUPS, [data.keys, r.data, false])
    }
  },
  async adasRepairLines({ commit, dispatch }, adas) {
    const r = await startLoading(dispatch, 'adasRepairLines', () => http.get(`decode/repairlines?adas=${adas}`))
    commit(types.SET_REPAIRLINES, r.data)
    return r.data
  },
  async inspectionReport({ commit, dispatch }, adasInspection) {
    const r = await startLoading(dispatch, 'inspectionReport', () => http.get(`decode/inspectionReport?adasInspection=${adasInspection}`))
    return r.data
  }
  // adasRepairLines
}



// WEBPACK FOOTER //
// ./src/store/modules/adas/actions.js